/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Visitor_Login_HeadingInputs */



/**
* | output |
* | --- |
* | "Visitor sign-in" |
*
* @param {Artifact_Visitor_Login_HeadingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_visitor_login_heading = /** @type {((inputs?: Artifact_Visitor_Login_HeadingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Visitor_Login_HeadingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Besucher-Anmeldung")
	return /** @type {LocalizedString} */ ("Visitor sign-in")
});